import { cva } from "class-variance-authority";

export const badgeVariants = cva(
  "inline-flex h-max items-center gap-1.5 rounded-xs px-2 py-1 text-xs font-medium font-sans capitalize transition-colors",
  {
    variants: {
      variant: {
        neutral: "bg-muted text-muted-foreground",
        primary: "bg-primary-muted text-primary",
        info:    "bg-info-muted text-info",
        success: "bg-success-muted text-success",
        warning: "bg-warning-muted text-warning",
        danger:  "bg-danger-muted text-danger",
      },
    },
    defaultVariants: {
      variant: "neutral",
    },
  }
);

export type BadgeVariant =
  | "neutral"
  | "primary"
  | "info"
  | "success"
  | "warning"
  | "danger";
